export const IS_BROWSER = typeof window !== 'undefined'

/** Minimum distance from chase cover hole to edge */
export const CHASE_COVER_HOLE_MIN_EDGE_DISTANCE_INCHES = 1
/** Minimum distance between chase cover holes */
export const CHASE_COVER_HOLE_MIN_BETWEEN_DISTANCE_INCHES = 1.5

export const BARNHILL_CREDIT_CARD_FEE = 0.03
